import { ONE_TWO } from './type';

export const typeList = [
  { label: '全部', id: '', value: 'all' },
  { label: '满减券', id: 1, value: 'full_minus' },
  { label: '折扣券', id: 2, value: 'immediate_minue' },
  { label: '立减券', id: 3, value: 'freight' },
];

export const statusList = [
  { label: '全部', id: '' },
  { label: '待生效', id: 0 },
  { label: '生效', id: 1 },
  { label: '失效', id: 2 },
];

export const listOperate = {
  waitAble: 0,
  able: 1,
  disable: 2,
};

export const restrictionList = [
  { label: '是', id: 1 },
  { label: '否', id: 0 },
];

export const ticketStatusList = {
  all: { text: '全部', key: 0 },
  has_received: { text: '已领取', key: 1 },
  has_checked: { text: '已核销', key: 2 },
  has_deleted: { text: '已作废', key: 3 },
};

export const typeMap = ['全部', '满减券', '折扣券', '立减券', '运费券'];
export const statusMap = ['待生效', '生效', '失效'];
export const restrictionMap = ['否', '是'];
export const ticketStatusMap = ['全部', '已领取', '已核销', '已作废'];

export const couponsTypeList = [
  { label: '门店', id: '0' },
  { label: '全平台', id: '1' },
  { label: '城市', id: '2' },
  { label: '商圈', id: '3' },
];

export const orderDeliveryList = [
  { label: '全部', id: 0 },
  { label: '外卖', id: 1 },
  { label: '自提', id: 2 },
  { label: '到店付', id: 3 },
  { label: '堂食', id: 4 },
];

//  是否对外售卖
export const oneTwoOP = [
  { label: '是', value: ONE_TWO.ONE },
  { label: '否', value: ONE_TWO.TWO },
];

export const oneTwoAOP = [{ label: '全部', value: '' }, ...oneTwoOP];
